import dayjs from 'dayjs';

export const DEFAULT_SEARCH_BILLS_DATA = {
  DateFrom: dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
  DateTo: dayjs().format('YYYY-MM-DD'),
  OrganizationIds: null,
  DocumentTypes: null,
  Statuses: null,
  RecordsPerPage: 20,
};
